'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBrightness3 = function MdBrightness3(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 3.4c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6c-1.7 0-3.4-0.2-5-0.7 6.8-2.1 11.6-8.4 11.6-15.9s-4.8-13.8-11.6-15.9c1.6-0.5 3.3-0.7 5-0.7z' })
        )
    );
};

exports.default = MdBrightness3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/brightness-3.js
// module id = 1253
// module chunks = 168707334958949